import { useLocation, Route, Routes } from "react-router-dom";
import { LoginPage } from "../pages/LoginPage";

export const AppRoute = () => {
  return (
    <Routes>
      <Route path={``} element={<LoginPage />} />
      <Route path={`:Text`} element={<LoginPage />} />
      <Route path={`:Text/:Token`} element={<LoginPage />} />  
    </Routes>
  );
};
